import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
const symptoms = ['Sientes que la operación depende demasiado de ti', 'El equipo trabaja… pero no con la claridad que debería', 'Hay desorden en procesos, decisiones o ejecución', 'El crecimiento trajo más problemas que control', 'Pasas el día resolviendo urgencias en lugar de dirigir', 'Delegar se vuelve difícil porque nada está realmente estructurado', 'Todo funciona… pero con fricción constante', 'Si te desconectas, las cosas empiezan a fallar'];
export function SymptomsSection() {
  return <section className="py-24 px-6 bg-navy border-t border-white/5" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <h2 className="text-3xl md:text-5xl font-serif text-center mb-16" data-id="element-162">
            Si tu negocio se siente así,{' '}
            <span className="text-gold" data-id="element-163">no es casualidad</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-164">
          {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.04} data-id="element-165">
              <div className="flex items-start gap-4 p-6 rounded-lg border border-gold/30 bg-white/[0.02] hover:bg-white/[0.04] transition-colors h-full" data-id="element-166">
                <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-167" />
                <p className="text-lg text-white/90 font-sans leading-relaxed" data-id="element-168">
                  {symptom}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-169">
          <p className="text-center text-xl text-gray-light italic max-w-3xl mx-auto" data-id="element-170">
            "Y probablemente ya lo has intentado solucionar trabajando más o
            organizándote mejor… Pero el problema no es ese."
          </p>
        </FadeIn>
      </div>
    </section>;
}